module.exports = __webpack_public_path__ + "static/img/card.6183412.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/card.png
// module id = qAxK
// module chunks = 6